import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_BUSINESS, GET_BUSINESS_BY_ID } from "../constants";

export const getBusiness = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`business/get_all`, data);
    if (response?.data?.status) {
      dispatch({ type: GET_BUSINESS, businesslist: response?.data?.response });
    } else {
      dispatch({ type: GET_BUSINESS, businesslist: [] });
    }
  } catch (err) {
   // console.error(err);
    dispatch({ type: GET_BUSINESS, businesslist: [] });
  }
};

export const addBusiness = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("business/create", data);
    if (response?.data?.status) {
      navigate(-1);
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }

   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateBusiness = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("business/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      // window.location.reload()
      navigate('/business')
      return response;
    }
  else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  }
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteBusiness =
  (data, setLoading, params) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(`business/delete`, data);
      if (response?.data?.status) {
        dispatch(getBusiness(params));
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // return response;
      }
     else{
      swal({
        text: response?.data?.response?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
     }
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

export const getBusinessById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`business/get_byid/${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_BUSINESS_BY_ID,
        businessbyid: response.data.response,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const deleteSingleBusiness= (data) => async dispatch =>{
  const response =await  axiosInstance.post("business/delete",data) 
  try {
    if (response?.data?.response) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500
      });
      window.location.reload()
      return
    }
    else {
      swal({
        text: response?.data?.message  ,
        icon: "error",
        button: "Close",
        timer: 1500
      });
    }
  } catch (error) {
    swal({
      text: 'Something went wrong. Please try again.',
      icon: "error",
      button: "Close",
      timer: 1500
    });
  }
}
